import { withStyles } from "@material-ui/core"
import TrendingTopicRow from "./TrendingTopicRow.view"

const styles = theme => ({})

export default withStyles(styles)(TrendingTopicRow)
